export default "__VITE_ASSET__CY7lzi6g__"